import type { GroupJSON, ModelingFormat } from 'balus-common';
import { GroupMemberSignUpMethod } from './GroupMemberSignUpMethod';

export class GroupSetting {
  constructor(
    public readonly availableSignUpMethods: GroupMemberSignUpMethod,
    public readonly enableIndividualViewModelPermissions: boolean,
    public readonly defaultModelingFormat: ModelingFormat
  ) {}

  dump(): GroupJSON['setting'] {
    const { availableSignUpMethods, enableIndividualViewModelPermissions, defaultModelingFormat } = this;
    return {
      availableSignUpMethods: availableSignUpMethods.dump(),
      enableIndividualViewModelPermissions,
      defaultModelingFormat,
    };
  }

  static load(dump: GroupJSON['setting']): GroupSetting {
    const { availableSignUpMethods, enableIndividualViewModelPermissions, defaultModelingFormat } = dump;
    return new this(
      GroupMemberSignUpMethod.load(availableSignUpMethods),
      enableIndividualViewModelPermissions || false,
      defaultModelingFormat
    );
  }

  static buildNew(defaultModelingFormat: ModelingFormat = 'CJK'): GroupSetting {
    return new this(GroupMemberSignUpMethod.buildNew(), true, defaultModelingFormat);
  }
}
